import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { WidgetExplanationContent } from "../types";
import { WidgetCard } from "./WidgetCard";

export type DonutSlice = {
    label: string;
    value: number;
    color: string;
};

type DonutCardProps = {
    title: string;
    explanation: WidgetExplanationContent;
    slices: Array<DonutSlice>;
    valueFormatter?: (value: number) => string;
    height?: number;
    headerControls?: React.ReactNode;
    isLoading?: boolean;
    isError?: boolean;
};

export const DonutCard = ({ title, explanation, slices, valueFormatter, height = 320, headerControls, isLoading, isError }: DonutCardProps) => {
    const total = slices.reduce((sum, slice) => sum + slice.value, 0);
    const formatValue = valueFormatter || ((value: number) => String(value));

    return (
        <WidgetCard title={title} explanation={explanation} bodyHeight={height} isLoading={isLoading} isError={isError} headerControls={headerControls}>
            <ResponsiveContainer width="100%" height={height}>
                <PieChart>
                    <Pie
                        data={slices}
                        dataKey="value"
                        nameKey="label"
                        innerRadius="45%"
                        outerRadius="80%"
                        stroke="none"
                        isAnimationActive={false}
                        label={(entry) => {
                            const pct = total > 0 ? ((entry.value / total) * 100).toFixed(1) : "0";
                            return `${formatValue(entry.value)} (${pct}%)`;
                        }}
                    >
                        {slices.map((slice) => (
                            <Cell key={slice.label} fill={slice.color} />
                        ))}
                    </Pie>
                    <Tooltip formatter={(value) => formatValue(Number(value))} />
                    <Legend />
                </PieChart>
            </ResponsiveContainer>
        </WidgetCard>
    );
};
